import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.1, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-xs uppercase tracking-[0.32em] text-[var(--gold)] ${className}`}>{children}</p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl font-normal leading-[1.02] tracking-tight ${className}`}>
    {children}
  </h2>
);
